import React, {Component} from "react";
import {DashboardValueVsExpectedCell} from "../base/DashboardValueVsExpectedCell";

export class DashboardFullPeriodACOSVsLastPeriodCell extends Component {
    render() {
        return <DashboardValueVsExpectedCell value={this.props.data.fluctuation_formatted_value}
                                             status={this.props.data.status}
                                             alertLevel={this.props.data.alert_level}
                                             alertSnoozed={this.props.data.alert_snoozed}
                                             fluctuation={this.props.data.fluctuation}
                                             fluctuationPercentage={this.props.data.fluctuation_formatted_percentage}
        />;
    }
}
